import React, { FunctionComponent, useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from '@/components/buttons';
import InputField from '@/components/inputs/inputField';
import { createTag, editTag, getTag } from '@/communication/tag';
import { ServerError } from '@/types/communication/serverResponse';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetch } from '@/hooks/useFetch';
import { BackButton } from '@/components/buttons/backButton';
interface Props {
    createMode?: boolean;
}

interface FormValues {
    name: string;
}

const TagDetails: FunctionComponent<Props> = (props) => {
    const { createMode } = props;
    const { tagId: tagIdParam } = useParams();
    const tagId = Number(tagIdParam);
    const nav = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formValues, setFormValues] = useState<FormValues>({ name: '' });
    const [validationErrors, setValidationErrors] = useState<any>();
    const { data, status } = useFetch({
        queryFn: () => getTag(tagId),
        disabled: Number.isNaN(tagId),
    });

    const handleChange = (fieldName: keyof FormValues, value): void => {
        setFormValues((prevValues) => ({ ...prevValues, [fieldName]: value }));
    };

    const handleSubmit = async (): Promise<void> => {
        setIsSubmitting(true);
        setValidationErrors(null);
        try {
            await (createMode ? createTag(formValues) : editTag({ id: tagId, name: formValues.name }));
            nav('/tags');
        } catch (error) {
            const serverError = error as ServerError;
            if (serverError?.type === 'validation') {
                setValidationErrors(serverError.payload);
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        if (status === 'fetched' && data) {
            setFormValues(data);
        }
    }, [data, status]);

    if (status === 'loading') {
        return <>Loading</>;
    }
    return (
        <StyledContent>
            <h1>{createMode ? 'Create' : 'Edit'} Tag</h1>
            <InputField
                value={formValues.name}
                label="Name"
                errorMessage={validationErrors?.name}
                onChange={(e) => handleChange('name', e.target.value)}
            />
            <div className="form-actions">
                <Button onClick={handleSubmit} disabled={isSubmitting}>
                    {createMode ? 'Create' : 'Save'}
                </Button>
                <BackButton />
            </div>
        </StyledContent>
    );
};

const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 1140px;
    margin: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    .form-actions {
        display: flex;
        gap: 1rem;
        margin-bottom: 5rem;
    }
`;

export default TagDetails;
